import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import useWatch from "@core-ui/hooks/useWatch";
import { useArticlePropsStore } from "@core-ui/stores/ArticlePropsStore/ArticlePropsStore.provider";
import getArticleItemLink from "@ext/article/LinkCreator/logic/getArticleItemLink";
import { useHasItemActions, useIsDeleteOnlyItem } from "@ext/item/EditMenu";
import type { ItemLink } from "@ext/navigation/NavigationLinks";
import { useState } from "react";

export const useCurrentItemActions = (itemLinks: ItemLink[], showActions: boolean) => {
	const [itemLink, setItemLink] = useState<ItemLink>(null);
	const { path, errorCode } = useArticlePropsStore(
		(state) => ({ path: state.data.ref.path, errorCode: state.data.errorCode }),
		"shallow",
	);
	const isReadOnly = PageDataContextService.value?.conf.isReadOnly;

	useWatch(() => {
		setItemLink(getArticleItemLink(itemLinks, path));
	}, [path]);

	const hasItemActions = useHasItemActions(itemLink, itemLinks);
	const isDeleteOnly = useIsDeleteOnlyItem();
	const hasActions = (!errorCode || errorCode === 500) && !!itemLink && showActions && hasItemActions;

	return { itemLink, setItemLink, isDeleteOnly, hasActions, isMenuVisible: !isReadOnly && hasActions };
};
